<template>
    <!--计划详情-->
    <div class="order-price-detail">
        <Row type="flex" justify="space-between" align="middle">
            <div class="title-l">
                <router-link to="/index/plan_price" class="span-box">
                    <Icon type="ios-arrow-back" />
                    <span>计划管理-详情</span>
                </router-link>
            </div>
        </Row>
        <div id="Print-s">
            <div class="receipt-head-box">
                <div class="receipt-label">
                    单据信息
                </div>
                <div class="receipt-info">
                    <Row>
                        <Col :span="8">
                            <span>计划单号：{{ form.projectId }}</span>
                        </Col>
                        <Col :span="8">
                            <span>计划状态：{{ form.projectStatus }}</span>
                        </Col>
                        <Col :span="8" :class="{'diff-color': diff.period}">
                            <span>计划期间：{{ form.period }}</span>
                        </Col>
                    </Row>
                    <Row>
                        <Col :span="8" :class="{'diff-color': diff.versionId}">
                            <span>计划版本：{{ form.versionId }}</span>
                        </Col>
                        <Col :span="8" :class="{'diff-color': diff.projectType}">
                            <span>计划类型：{{ form.projectType }}</span>
                        </Col>
                        <Col :span="8" :class="{'diff-color': diff.settleChannel}">
                            <span>结算渠道：{{ form.settleChannel }}</span>
                        </Col>
                    </Row>
                    <Row :class="{'diff-color': diff.organNo}">
                        <Col :span="8">
                            <span>单位编码：{{ form.organNo }}</span>
                        </Col>
                        <Col :span="16">
                            <span>单位名称：{{ form.path }}</span>
                        </Col>
                    </Row>
                    <Row>
                        <Col :span="8" :class="{'diff-color': diff.quotationNo}">
                            <span>询价单号：{{ form.quotationNo }}</span>
                        </Col>
                        <Col :span="16" :class="{'diff-color': diff.abstract}">
                            <span>备注：{{ form.abstract }}</span>
                        </Col>
                    </Row>
                    <Row>
                        <Col :span="24">
                            <span>是否调整：{{ $route.query.isUpdated === '1' ? '是' : '否' }}</span>
                            <span class="primary-color" v-if="$route.query.isUpdated === '1'">
                                <span @click="lookHistory">查看原计划</span>
                                <span @click="showDiffer">显示差异</span>
                            </span>
                        </Col>
                    </Row>
                    <Row class="print-row" v-if="showhistory">
                        <Col :span="24">
                            <Row>
                                <Col :span="8">
                                    <span>原计划单号：{{ formHis.projectId }}</span>
                                </Col>
                                <Col :span="8">
                                    <span>计划状态：{{ formHis.projectStatus }}</span>
                                </Col>
                                <Col :span="8">
                                    <span>计划期间：{{ formHis.period }}</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col :span="8">
                                    <span>计划版本：{{ formHis.versionId }}</span>
                                </Col>
                                <Col :span="8">
                                    <span>计划类型：{{ formHis.projectType }}</span>
                                </Col>
                                <Col :span="8">
                                    <span>结算渠道：{{ formHis.settleChannel }}</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col :span="8">
                                    <span>单位编码：{{ formHis.organNo }}</span>
                                </Col>
                                <Col :span="16">
                                    <span>单位名称：{{ formHis.path }}</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col :span="8">
                                    <span>询价单号：{{ formHis.quotationNo }}</span>
                                </Col>
                                <Col :span="16">
                                    <span>备注：{{ formHis.abstract }}</span>
                                </Col>
                            </Row>
                            <Table :columns="columns" :data="productsHis"
                                :height="productsHis.length > 10 ? 500 : 'auto'"></Table>
                            <Row class="table-footer-box" type="flex" justify="end">
                                <div class="monry-detail-info">
                                    <span>
                                        共： <b class="weight"> {{ formHis.totalItem || 0 }} </b>项
                                    </span>
                                    <span>
                                        数量合计： <b class="weight"> {{ formHis.totalNumber || 0 }} </b>
                                    </span>
                                    <span>
                                        金额合计： <b class="weight"> ￥{{ formHis.priceSum }} </b>元
                                    </span>
                                </div>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </div>
            <div class="receipt-head-box">
                <div class="receipt-label">
                    物资信息
                </div>
                <Table :columns="columns" :data="products" :loading="loading"
                        :height="products.length > 10 ? 500 : 'auto'"
                        :row-class-name="rowClassName"></Table>
                <Row class="table-footer-box" type="flex" justify="end">
                    <div class="monry-detail-info">
                        <span>
                            共： <b class="weight"> {{ form.totalItem || 0 }} </b>项
                        </span>
                        <span>
                            数量合计： <b class="weight"> {{ form.totalNumber || 0 }} </b>
                        </span>
                        <span>
                            金额合计： <b class="weight"> ￥{{ form.priceSum }} </b>元
                        </span>
                    </div>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
import { getOneProject } from '@/graphql/graphql.js';
export default {
    data() {
        return {
            loading: false,
            columns: [
                {
                    title: '行项目',
                    key: 'serialNum',
                    minWidth: 80
                },
                {
                    title: '物资名称',
                    key: 'productName',
                    minWidth: 100
                },
                {
                    title: '物资编码',
                    key: 'productNo',
                    minWidth: 100
                },
                {
                    title: '物资分类',
                    key: 'classifyName',
                    minWidth: 100
                },
                {
                    title: '物资规格',
                    key: 'productSpectype',
                    minWidth: 100
                },
                {
                    title: '数量',
                    key: 'productCount',
                    minWidth: 100
                },
                {
                    title: '单价(元)',
                    key: 'unitPrice',
                    minWidth: 120
                },
                {
                    title: '金额(元)',
                    key: 'totalPrice',
                    minWidth: 120
                }
            ],
            form: {},
            products: [],
            formHis: {},
            productsHis: [],
            showhistory: false,
            diff: {},
            diffProducts: [],
            diffIds: []
        };
    },

    mounted() {
        if (this.$route.query.projectId) {
            this.getOriginReceiptDetail();
        } else {
            this.$setNotice('请选择计划');
            this.$router.push('/index/plan_price');
        }
    },

    methods: {
        // 查看单据详情
        getOriginReceiptDetail() {
            this.loading = true;
            this.$apollo.query({
                query: getOneProject,
                context: { useApi1: false },
                variables: {
                    projectId: this.$route.query.projectId
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                this.loading = false;
                const data = res.data.getOneProject;
                if (data && data.code === 200) {
                    this.form = data.data;
                    this.products = data.data.items;
                    let priceSum = 0;
                    this.products.forEach(ele => {
                        priceSum += Number(ele.totalPrice);
                    });
                    this.form.priceSum = priceSum.toFixed(2);
                    if (data.data.history.projectId) {
                        this.formHis = data.data.history;
                        if (data.data.history) {
                            this.productsHis = data.data.history.items;
                            let priceSum1 = 0;
                            this.productsHis.forEach(ele => {
                                priceSum1 += Number(ele.totalPrice);
                            });
                            this.formHis.priceSum = priceSum1.toFixed(2);
                        }
                    }
                } else {
                    this.$setNotice('详情获取失败,请重新选择');
                }
            }).catch(() => {
                this.loading = false;
            });
        },
        lookHistory() {
            this.showhistory = !this.showhistory;
        },
        showDiffer() {
            this.diff = this.diffObj(this.formHis, this.form);
            const arrDiff1 = this.arrayDifferenceById(this.products, this.productsHis, 'productNo');
            const arrDiff2 = this.arrayDifferenceById(this.products, this.productsHis, 'productCount');
            const arrDiff3 = this.arrayDifferenceById(this.products, this.productsHis, 'unitPrice');
            const diffProducts = this.mergeUnique(arrDiff1, arrDiff2, arrDiff3);
            diffProducts.forEach(item => {
                this.diffIds.push(item.productNo);
            });
        },
        mergeUnique(arr1, arr2, arr3) {
            return [...new Set([...arr1, ...arr2, ...arr3])];
        },
        diffObj(obj1, obj2) {
            const diff = {};
            const keys1 = Object.keys(obj1);
            const keys2 = Object.keys(obj2);
            keys1.concat(keys2).forEach(key => {
                if (obj1[key] !== obj2[key]) {
                    diff[key] = obj2[key];
                }
            });
            return diff;
        },
        arrayDifferenceById(arr1, arr2, key) {
            return arr1.filter(item1 =>
                !arr2.some(item2 => item2[key] === item1[key]));
        },
        rowClassName(row) {
            if (this.diffIds.includes(row.productNo)) {
                return 'table-warning-row';
            } else {
                return '';
            }
        }
    }
};
</script>

<style lang="stylus">

@import '../../assets/stylus/views/plan-order-detail.styl'

</style>



// WEBPACK FOOTER //
// src/views/PlanPrice/detail.vue